import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import Vant from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
import './assets/style/common.scss'

import VConsole from 'vconsole';
// new VConsole()

const app = createApp(App)
app.use(Vant);
app.use(Lazyload);
app.use(router)
app.mount('#app')
